import axios from 'axios';
import dayjs from 'dayjs';
import Micromodal from 'micromodal';
import { FC, useState } from 'react';
import NumberFormat from 'react-number-format';
import { Link, useHistory, useParams } from 'react-router-dom';
import { Setting } from '../App';
import MetafieldItem from '../components/MetafieldItem';
import { SpinButton } from '../components/SpinButton';
import { CUSTOMER_API_URL } from '../constants';
import { useSubscriptionDetail } from '../hooks/use-subscription-detail';
import { Product, useSubscriptionLineEditProduct } from '../hooks/use-subscription-line-edit-product';
import { useSubscriptionLineEditVariant } from '../hooks/use-subscription-line-edit-variant';
import { productsData } from '../productsDataPrd';
import base from '../styles/Base.module.css';

export const SubscriptionLineEditVariantShokutasu: FC<{ setting: Setting }> = ({ setting }) => {
  const [productDetailModalDisplay, setProductDetailModalDisplay] = useState(false);
  const [productQuantityModalDisplay, setProductQuantityModalDisplay] = useState(false);

  const [modalMainImage, setModalMainImage] = useState<string>('');
  const [targetProductDetail, setTargetProductDetail] = useState<any>(null);
  // const [targetProductDetailMetafields, setTargetProductDetailMetafields] = useState<any>([
  //   {
  //     title: '内容量',
  //     content: '1本',
  //   },
  //   {
  //     title: '原材料',
  //     content: '1本',
  //   },
  //   {
  //     title: '栄養成分（推定値）＊1個装当たり',
  //     content: '1本',
  //   },
  //   {
  //     title: 'アレルギー',
  //     content: '1本',
  //   },
  //   {
  //     title: '商品の大きさ / 重量（1個当たり）',
  //     content: '1本',
  //   },
  //   {
  //     title: 'お召し上がり方法',
  //     content: '1本',
  //   },
  //   {
  //     title: '賞味期限',
  //     content: '保存方法',
  //   },
  //   {
  //     title: '保存上の注意事項',
  //     content: '保存方法',
  //   },
  // ]);
  const [targetLineQuantity, setTargetLineQuantity] = useState<number>(1);
  const [targetVariantId, setTargetVariantId] = useState<string>('');
  const [isLoading, setIsLoading] = useState(false);
  const [targetSubscriptionContractId, setTargetSubscriptionContractId] = useState<string>('');
  const [targetLineId, setTargetLineId] = useState<string>('');

  const reactRouterHistory = useHistory();

  const { id, productId, lineId } = useParams<{ id: string; productId: string; lineId: string }>();

  const {
    subscription,
    productDetail,
    // lineId,
    variant,
    quantity,
    onChangeVariant,
    onChangeQuantify,
    onSelectItem,
    onClickCompleteAction,
    isProc,
    onHandleAddItem,
  } = useSubscriptionLineEditVariant(setting);
  const { products, infoMessage, page, hasNextPage, paginate } = useSubscriptionLineEditProduct(setting);

  const {
    pageStatus,
    onClickQuantityAction,
    onChangeQuantity,
    onClickShokutasuQuantityAction,
    onClickRemoveProduct,
    removeItem,
    onClickRemoveAction,
    allowModifyDay,
  } = useSubscriptionDetail(setting);

  console.log('subscription in SubscriptionLineEditVariant', subscription);
  console.log('productDetail', productDetail);
  console.log('lineId', lineId);
  console.log('variant', variant);
  // if (!productDetail || !subscription || !variant) {
  //   return <></>;
  // }

  if (!products) {
    return <></>;
  }
  if (!subscription) {
    return <></>;
  }

  const handleImageClick = async (product: Product) => {
    console.log('product', product);
    const product_handle = product.onlineStorePreviewUrl?.slice(-11);
    console.log('product_handle', product_handle);
    console.log('productsData', productsData);
    const target_product = productsData.find((p) => product.onlineStorePreviewUrl?.includes(p.url!));
    console.log('target_product', target_product);
    setProductDetailModalDisplay(true);
    setTargetProductDetail({
      ...target_product,
      onlineStorePreviewUrl: product.onlineStorePreviewUrl,
    });
    setModalMainImage(target_product!.featured_image);
  };

  const handleAddProduct = (product: any) => {
    console.log('product', product);
    const product_handle = product.onlineStorePreviewUrl?.slice(-11);
    console.log('product_handle', product_handle);
    console.log('productsData', productsData);
    const target_product = productsData.find((p) => product.onlineStorePreviewUrl?.includes(p.url!));
    console.log('target_product', target_product);
    setProductDetailModalDisplay(true);
    setTargetProductDetail({
      ...target_product,
      ...product,
      onlineStorePreviewUrl: product.onlineStorePreviewUrl,
    });
    // const updateTargetProductDetailMetafields =
    //   target_product && target_product.metafields
    //     ? target_product.metafields.map((mf: any) => {
    //         return {
    //           ...mf,
    //           open: false,
    //         };
    //       })
    //     : [];
    // setTargetProductDetailMetafields(updateTargetProductDetailMetafields);
    setModalMainImage(target_product!.featured_image!);
  };

  const handleQuantity = (product: any, defaultQuantity: number, subscriptionContractId: string) => {
    console.log('product', product);
    const product_handle = product.onlineStorePreviewUrl?.slice(-11);
    console.log('product_handle', product_handle);
    console.log('productsData', productsData);
    const target_product = productsData.find((p) => product.onlineStorePreviewUrl?.includes(p.url));
    console.log('target_product', target_product);
    setTargetLineQuantity(defaultQuantity);
    setTargetVariantId(product.variants[0].id);
    setTargetSubscriptionContractId(subscriptionContractId);
    setTargetLineId(
      subscription!.subscriptionLines.find((line) => line.variantId.includes(product.variants[0].id.toString()))!.lineId,
    );
    setProductQuantityModalDisplay(true);
    setTargetProductDetail({
      ...target_product,
      onlineStorePreviewUrl: product.onlineStorePreviewUrl,
    });
    // setTargetProductDetailMetafields(
    //   target_product
    //     ? target_product.metafields?.map((mf) => {
    //         return {
    //           ...mf,
    //           open: false,
    //         };
    //       })
    //     : []
    // );
    setModalMainImage(target_product!.featured_image!);
    console.log('targetProductDetail', targetProductDetail);
    console.log('targetLineId', targetProductDetail);
  };

  const updateQuantity = () => {
    console.log('targetProductDetail', targetProductDetail);
    onClickShokutasuQuantityAction({
      variantId: `gid://shopify/ProductVariant/${targetProductDetail.variants[0].id}`,
      subscriptionId: targetSubscriptionContractId,
      lineId: targetLineId,
      quantity: targetLineQuantity,
    });
  };

  const handlePreviewImageClick = (src: string) => {
    setModalMainImage(src);
  };

  // この商品を追加する ボタンのクリック時の処理
  const handleAddItem = async () => {
    if (subscription!.shop.showStockAlert) {
      try {
        const response = await axios.post(
          `${CUSTOMER_API_URL}?action=checkVariantSoldOut`,
          {
            variantId: `gid://shopify/ProductVariant/${targetProductDetail.variants[0].id}`,
          },
          {
            headers: { Authorization: setting.token },
          },
        );

        if (response.data.soldOut) {
          Micromodal.show('modal-stock-error');

          return;
        }
      } catch (e) {
        console.log((e as Error).message);

        return;
      }
    }
    setIsLoading(true);
    console.log('handleAddItem');
    console.log('targetProductDetail', targetProductDetail);
    console.log('subscription', subscription);
    // console.log('id', id);
    // console.log('productId', productId);
    console.log('lineId', lineId);
    // const res_data = await loadSubscriptionLinePlanForOnHandleAddItem({ id: subscription!.subscriptionContractId });
    // console.log('res_data', res_data);
    let sellingPlanName = '';
    // if (subscription!.subscriptionLines[0].sellingPlanId === 'gid://shopify/SellingPlan/6021873854') {

    // dev
    // if (subscription!.subscriptionLines[0].sellingPlanId === 'gid://shopify/SellingPlan/6021873854') {
    //   sellingPlanName = '週1回お届けプラン';
    // } else if (subscription!.subscriptionLines[0].sellingPlanId === 'gid://shopify/SellingPlan/6024298686') {
    //   sellingPlanName = '2週に1回お届けプラン';
    // } else {
    //   sellingPlanName = '4週に1回お届けプラン';
    // }

    //prd
    if (
      subscription!.subscriptionLines[0].sellingPlanId === 'gid://shopify/SellingPlan/3063906558' ||
      subscription!.subscriptionLines[0].sellingPlanId === 'gid://shopify/SellingPlan/3561259262'
    ) {
      sellingPlanName = '週1回ご注文プラン';
    } else if (
      subscription!.subscriptionLines[0].sellingPlanId === 'gid://shopify/SellingPlan/3063939326' ||
      subscription!.subscriptionLines[0].sellingPlanId === 'gid://shopify/SellingPlan/3561292030'
    ) {
      sellingPlanName = '2週に1回ご注文プラン';
    } else {
      sellingPlanName = '4週に1回ご注文プラン';
    }

    // stg
    // if (subscription!.subscriptionLines[0].sellingPlanId === 'gid://shopify/SellingPlan/4637458672') {
    //   sellingPlanName = '週1回お届けプラン';
    // } else if (subscription!.subscriptionLines[0].sellingPlanId === 'gid://shopify/SellingPlan/4637491440') {
    //   sellingPlanName = '2週に1回お届けプラン';
    // } else {
    //   sellingPlanName = '4週に1回お届けプラン';
    // }
    onHandleAddItem({
      // id: 'gid%3A%2F%2Fshopify%2FSubscriptionContract%2F3215687870',
      id: id,
      planId: subscription!.subscriptionLines[0].sellingPlanId!,
      planName: sellingPlanName,
      // subscriptionLineOnlineStorePreviewUrl: `https://hamaya-jt-dev.myshopify.com${targetProductDetail.url}`,
      subscriptionLineOnlineStorePreviewUrl: `https://tablemark-prd.myshopify.com${targetProductDetail.url}`,
      productId: productId,
      // variantId: 'gid://shopify/ProductVariant/42893764755710',
      variantId: `gid://shopify/ProductVariant/${targetProductDetail.variants[0].id}`,
      // variantImage: 'https://cdn.sh  opify.com/s/files/1/0638/1014/2462/products/BE-0017-001_01.png?v=1655178948',
      variantImage: targetProductDetail.featured_image,
      title: targetProductDetail.title,
      // variantTitle: targetProductDetail.variants[0].name,
      variantTitle: '',
      quantity: '1',
      variantPrice: (targetProductDetail.variants[0].price / 100).toString(),
      variantSku: targetProductDetail.variants[0].sku,
    })
      .then(() => {
        setIsLoading(false);
      })
      .catch(() => {
        setIsLoading(false);
      });
    // onSelectItem();
  };

  const actionType = lineId === 'new' ? '追加' : '変更';
  const oldSubscriptionLine =
    subscription === undefined
      ? undefined
      : subscription.subscriptionLines.find((line) => line.lineId === decodeURIComponent(targetLineId));
  const oldQuantity = oldSubscriptionLine === undefined ? 1 : oldSubscriptionLine.quantity;

  console.log('subscription in SubscriptionLineEditVariant', subscription);

  console.log('oldSubscriptionLine', oldSubscriptionLine);

  const handlePaginatePrev = (page_num: number) => {
    paginate(page_num - 1);
  };

  const handlePaginateNext = (page_num: number) => {
    paginate(page_num + 1);
  };

  let prevPageHtml = <></>;
  if (page > 0) {
    prevPageHtml = (
      <div className={base.sectionReverseBtn} onClick={() => handlePaginatePrev(page)}>
        前のページへ
      </div>
    );
  }

  let nextPageHtml = <></>;
  if (hasNextPage) {
    nextPageHtml = (
      <div className={`${base.sectionReverseBtn} ${page > 0 ? base.ml20 : ''}`} onClick={() => handlePaginateNext(page)}>
        次のページへ
      </div>
    );
  }
  console.log('products1', products);

  const alternativeProducts = products!
    .filter((product) => {
      // 商品のバリエーション全てが定期購買に登録済み
      if (
        product.variants.every((variant) => subscription.subscriptionLines.some((line) => line.variantId === variant.variantId))
      )
        return false;

      // 商品のバリエーション全てが、配送あり定期購買で配送なし商品、または配送なし定期購買で配送あり商品
      if (
        product.variants.every(
          (variant) =>
            (variant.requiresShipping && !subscription.deliveryCountryCode) ||
            (!variant.requiresShipping && !!subscription.deliveryCountryCode),
        )
      )
        return false;

      return true;
    })
    .map((product) => {
      return {
        ...product,
        subscribed: false,
        quantity: 0,
      };
    });

  // 契約済み商品
  const unAlternativeProducts = products
    .filter((product) => {
      if (
        product.variants.every((variant) => subscription.subscriptionLines.some((line) => line.variantId === variant.variantId))
      )
        return true;

      return false;
    })
    .map((product) => {
      return {
        ...product,
        subscribed: true,
        quantity: subscription.subscriptionLines.find((line) => line.variantId === product.variants[0].variantId)!.quantity,
      };
    });
  console.log('unAlternativeProducts', unAlternativeProducts);
  console.log('alternativeProducts', alternativeProducts);

  // displayedProducts
  const displayedProducts = [...unAlternativeProducts, ...alternativeProducts].map((dp: any) => {
    const productInStaticData = productsData.find((p) => dp.onlineStorePreviewUrl.includes(p.handle.toString()));
    // const dpSubscription = subscription.subscriptionLines.find((line) => line.productId === dp.productId);
    return {
      ...dp,
      ...productInStaticData,
      // quantity: dp.subscribed && dpSubscription ? dpSubscription.quantity : 0, // 0 or 契約中の個数
    };
  });

  console.log('displayedProducts', displayedProducts);

  console.log('products', products);
  console.log('subscription', subscription);
  console.log('alternativeProducts', alternativeProducts);
  console.log('targetProductDetail', targetProductDetail);

  // const updated_products = products!.map((ap) => {
  //   const target_product = productsData.find((p) => ap.onlineStorePreviewUrl?.includes(p.url));
  //   const subscribed = subscription.subscriptionLines.find((line) => line.productId === ap.productId);
  //   return {
  //     ...ap,
  //     ...target_product,
  //     subscribed: subscribed ? true : false, // True or False
  //     subscribed_quantity: subscribed ? subscribed.quantity : 0, // 0 or 契約中の個数
  //     subscribed_line: subscribed, // 契約中のline
  //     metafields: target_product!.metafields,
  //   };
  // });

  // if (updated_products.length === 0 && page === 0) {
  //   return (
  //     <>
  //       <p
  //         dangerouslySetInnerHTML={{
  //           __html: 'この商品は変更できません。<br/>店舗にお問い合わせください。',
  //         }}
  //       />
  //       {subscription ? (
  //         <div className="huckleberry-subscription-product-edit back">
  //           <Link to={`/subscriptions/${encodeURIComponent(subscription!.subscriptionContractId)}`}>戻る</Link>
  //         </div>
  //       ) : (
  //         <></>
  //       )}
  //     </>
  //   );
  // }

  const deliveryPriceCurrency =
    subscription.deliveryPriceCurrencyCode === 'JPY' ? '円' : subscription.deliveryPriceCurrencyCode;

  return (
    <>
      <div>
        {productDetailModalDisplay && (
          <>
            <div className={base.modalCover} onClick={() => setProductDetailModalDisplay(false)}></div>
            <div className={base.modal}>
              <h2 className={base.modalTitle}>{targetProductDetail && targetProductDetail.title} の詳細</h2>
              <div className={base.modalContent}>
                {/* 画像 */}
                <div className={base.modalContentLeft}>
                  <div className={base.modalImageMain}>
                    <img className={base.modalImageMainImage} src={modalMainImage} />
                  </div>
                  <div className={base.modalImageList}>
                    {targetProductDetail &&
                      targetProductDetail.media.map((m: any, index: number) => (
                        <div
                          key={`preview_image_${index}`}
                          className={`${base.modalImageItem} ${modalMainImage === m.src ? base.modalImageItem__active : ''}`}
                          onClick={() => handlePreviewImageClick(m.src)}
                        >
                          <img src={m.preview_image.src} alt="" className={base.modalImageItemImage} />
                        </div>
                      ))}
                  </div>
                </div>

                {/* 商品詳細 */}
                <div className={base.modalContentRight}>
                  {targetProductDetail && (
                    <div>
                      <div className={base.modalContentTitle}>{targetProductDetail.title}</div>
                      <div className={base.modalContentDesc}>{targetProductDetail.description}</div>
                      <div className={base.allergyCaution}>{targetProductDetail.allergy_caution}</div>
                      <div className={base.modalContentPrice}>
                        {targetProductDetail.isSetItem ? (
                          <p className={`${base.modalContentPriceLine} ${base.modalContentPriceLine__right}`}>
                            セット価格:
                            <NumberFormat
                              displayType="text"
                              value={Math.round((targetProductDetail.price / 100) * 0.95)}
                              thousandSeparator={true}
                              suffix={deliveryPriceCurrency}
                              className={base.red}
                            />
                            <span className={base.red}>-</span>
                          </p>
                        ) : (
                          <p className={`${base.modalContentPriceLine} ${base.modalContentPriceLine__right}`}>
                            定期価格:
                            <NumberFormat
                              displayType="text"
                              value={Math.round((targetProductDetail.price / 100) * 0.95)}
                              thousandSeparator={true}
                              suffix={deliveryPriceCurrency}
                              className={base.red}
                            />
                            <span className={base.red}>-</span>
                          </p>
                        )}
                      </div>

                      {targetProductDetail && (
                        <div className={base.modalFooter}>
                          <button
                            className={`${base.sectionReverseBtn} ${base.modalFooterBtnBack}`}
                            onClick={() => setProductDetailModalDisplay(false)}
                          >
                            戻る
                          </button>
                          <button
                            className={`${base.sectionBtn} ${base.ml20} ${base.modalFooterBtnAdd}`}
                            disabled={isLoading}
                            onClick={handleAddItem}
                          >
                            この商品を追加する
                          </button>
                        </div>
                      )}

                      <div className={base.modalContentMetaFields}>
                        {targetProductDetail.metafields.map((mf: any, index: number) => (
                          <MetafieldItem
                            key={`mf_${index}`}
                            title={mf.title}
                            content={mf.content}
                            content2={mf.content2 ? mf.content2 : ''}
                            allergy_note={targetProductDetail.allergy_note ? targetProductDetail.allergy_note : ''}
                            mf={mf}
                            isSetItem={targetProductDetail.isSetItem ? true : false}
                          />
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </>
        )}

        {productQuantityModalDisplay && (
          <>
            <div className={base.modalCover} onClick={() => setProductQuantityModalDisplay(false)}></div>
            <div className={base.modal}>
              <h2 className={base.modalTitle}>{targetProductDetail && targetProductDetail.title} の詳細</h2>
              <div className={base.modalContent}>
                {/* 画像 */}
                <div className={base.modalContentLeft}>
                  <div className={base.modalImageMain}>
                    <img className={base.modalImageMainImage} src={modalMainImage} />
                  </div>
                  <div className={base.modalImageList}>
                    {targetProductDetail &&
                      targetProductDetail.media.map((m: any, index: number) => (
                        <div
                          key={`preview_image_${index}`}
                          className={`${base.modalImageItem} ${modalMainImage === m.src ? base.modalImageItem__active : ''}`}
                          onClick={() => handlePreviewImageClick(m.src)}
                        >
                          <img src={m.preview_image.src} alt="" className={base.modalImageItemImage} />
                        </div>
                      ))}
                  </div>
                </div>

                {/* 商品詳細 */}
                <div className={base.modalContentRight}>
                  {targetProductDetail && (
                    <div>
                      <div className={base.modalContentTitle}>{targetProductDetail.title}</div>
                      <div className={base.modalContentDesc}>{targetProductDetail.description}</div>
                      <div className={base.modalContentPrice}>
                        {targetProductDetail.isSetItem ? (
                          <p className={`${base.modalContentPriceLine} ${base.modalContentPriceLine__right}`}>
                            セット価格:
                            <NumberFormat
                              displayType="text"
                              value={Math.round((targetProductDetail.price / 100) * 0.95)}
                              thousandSeparator={true}
                              suffix={deliveryPriceCurrency}
                              className={base.red}
                            />
                            <span className={base.red}>-</span>
                          </p>
                        ) : (
                          <p className={`${base.modalContentPriceLine} ${base.modalContentPriceLine__right}`}>
                            定期価格:
                            <NumberFormat
                              displayType="text"
                              value={Math.round((targetProductDetail.price / 100) * 0.95)}
                              thousandSeparator={true}
                              suffix={deliveryPriceCurrency}
                              className={base.red}
                            />
                            <span className={base.red}>-</span>
                          </p>
                        )}
                      </div>

                      <div className={`${base.modalFooter} ${base.modalFooterChangeQuantity}`}>
                        <p className={base.modalFooterNote}>
                          数量を選択してください。
                          <br />
                          変更は次回のご注文から反映されます。
                        </p>
                        {/* 数量変化 */}
                        <div className={`${base.counter} ${base.modalFooterCounterBlock} change-amount`}>
                          <span className={base.counterMinus} onClick={() => setTargetLineQuantity(targetLineQuantity - 1)}>
                            -
                          </span>
                          <span className={base.counterInput}>{targetLineQuantity}</span>
                          <span className={base.counterPlus} onClick={() => setTargetLineQuantity(targetLineQuantity + 1)}>
                            +
                          </span>
                        </div>

                        <div className={`${base.modalFooterCounterBlock}`}>
                          <button className={`${base.sectionBtn}`} onClick={updateQuantity}>
                            数量を変更する
                          </button>
                        </div>

                        <div className={`${base.modalFooterCounterBlock}`}>
                          <button className={base.sectionReverseBtn} onClick={() => setProductQuantityModalDisplay(false)}>
                            戻る
                          </button>

                          <button className={base.sectionReverseBtn} onClick={() => onClickRemoveProduct(oldSubscriptionLine!)}>
                            削除する
                          </button>
                        </div>
                      </div>

                      <div className={base.modalContentMetaFields}>
                        {targetProductDetail.metafields.map((mf: any, index: number) => (
                          <MetafieldItem
                            key={`mf_${index}`}
                            title={mf.title}
                            content={mf.content}
                            content2={mf.content2 ? mf.content2 : ''}
                            allergy_note={targetProductDetail.allergy_note ? targetProductDetail.allergy_note : ''}
                            mf={mf}
                            isSetItem={targetProductDetail.isSetItem ? targetProductDetail.isSetItem : ''}
                          />
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </>
        )}

        <h2>お届け商品の追加・変更</h2>
        <p>※すべての商品の数量を0にすることはできません。</p>
        {/* <h2>商品の{actionType}</h2>
      <p>次回、ご注文の商品を{actionType}します。下記の商品から選択してください。</p> */}

        <div className={`${base.productList} product`}>
          {displayedProducts.map((product: any, pidx) => {
            return (
              <div className={base.productItem} key={pidx}>
                <main className={base.productItemMain}>
                  {product.subscribed ? (
                    <>
                      <figure
                        className={base.productItemFigure}
                        onClick={() => handleQuantity(product, product.quantity, subscription.subscriptionContractId)}
                      >
                        {product.subscribed && (
                          <div className={base.productItemBadge}>
                            お届け
                            <br />
                            予定品
                          </div>
                        )}
                        <img
                          className={base.productItemImage}
                          src={product.images.length > 0 ? product.images[0] : ''}
                          alt=""
                        />
                      </figure>
                    </>
                  ) : (
                    <>
                      <figure className={base.productItemFigure} onClick={() => handleImageClick(product)}>
                        {product.subscribed && (
                          <div className={base.productItemBadge}>
                            お届け
                            <br />
                            予定品
                          </div>
                        )}
                        <img
                          className={base.productItemImage}
                          src={product.images.length > 0 ? product.images[0] : ''}
                          alt=""
                        />
                      </figure>
                    </>
                  )}
                  <div className={base.productItemInfo}>
                    <p className={base.productItemTitle}>{product.title}</p>
                    {product.isSetItem ? (
                      <p className={base.productItemSubscriptionLabel}>セット価格</p>
                    ) : (
                      <p className={base.productItemSubscriptionLabel}>定期購入価格</p>
                    )}
                    {product.isSetItem ? (
                      <div className={base.productItemPrice}>
                        {/* <span className={base.productItemPriceSubscription}>
                          <NumberFormat displayType='text' value={Math.round(product.price / 100)} thousandSeparator={true} suffix={deliveryPriceCurrency} />
                        </span> */}
                        <span className={base.productItemPriceSubscription}>
                          <NumberFormat
                            displayType="text"
                            value={Math.round((product.price / 100) * 0.95)}
                            thousandSeparator={true}
                            suffix={deliveryPriceCurrency}
                          />
                        </span>
                      </div>
                    ) : (
                      <div className={base.productItemPrice}>
                        <span className={base.productItemPriceOriginal}>
                          <NumberFormat
                            displayType="text"
                            value={product.price / 100}
                            thousandSeparator={true}
                            suffix={deliveryPriceCurrency}
                          />
                        </span>
                        <span className={base.productItemPriceArrow}>→</span>
                        <span className={base.productItemPriceSubscription}>
                          <NumberFormat
                            displayType="text"
                            value={Math.round((product.price / 100) * 0.95)}
                            thousandSeparator={true}
                            suffix={deliveryPriceCurrency}
                          />
                        </span>
                      </div>
                    )}
                  </div>
                </main>
                <footer className={base.productItemFooter}>
                  {product.subscribed ? (
                    <>
                      <div className={base.counterBlock}>
                        <span className={base.counterLabel}>数量：</span>
                        <button
                          onClick={() => handleQuantity(product, product.quantity, subscription.subscriptionContractId)}
                          className={`${base.counter} change-amount`}
                          disabled={subscription.disabled}
                        >
                          <span className={base.counterMinus}>-</span>
                          <span className={base.counterInput}>{product.quantity}</span>
                          <span className={base.counterPlus}>+</span>
                        </button>
                      </div>

                      <div className="micromodal" id={`modal-quantity-modify`} aria-hidden="true">
                        <div className={`micromodal-overlay ${base.micromodalOverlay}`} tabIndex={-1}>
                          <div
                            role="dialog"
                            className={base.micromodalOverlayDialog}
                            aria-modal="true"
                            aria-labelledby="modal-quantity-modify-title"
                          >
                            <header>
                              {/* <button
                                aria-label="Close modal"
                                className={base.closeModal}
                                data-micromodal-close
                              ></button> */}
                              <h2 id="modal-quantity-modify-title">数量の変更</h2>
                            </header>
                            <main id="modal-quantity-modify-content">
                              <p>
                                数量を選択してください。
                                <br />
                                変更は次回のご注文から反映されます。
                              </p>
                              <SpinButton
                                min={1}
                                value={product.subscribed ? product.quantity : 1}
                                onChange={onChangeQuantity}
                              />
                            </main>
                            <footer>
                              <button
                                className={base.sectionBtn}
                                disabled={pageStatus.quantityAction}
                                onClick={onClickQuantityAction}
                              >
                                保存
                              </button>
                            </footer>
                          </div>
                        </div>
                      </div>
                      <div
                        className="micromodal"
                        id={`modal-quantity-modify-complete-gid://shopify/ProductVariant/${product.variants[0].id}`}
                        aria-hidden="true"
                      >
                        <div className={`micromodal-overlay ${base.micromodalOverlay}`} tabIndex={-1}>
                          <div
                            role="dialog"
                            className={base.micromodalOverlayDialog}
                            aria-modal="true"
                            aria-labelledby="modal-quantity-modify-complete-title"
                          >
                            <header>
                              {/* <button
                                aria-label="Close modal"
                                className={base.closeModal}
                                data-micromodal-close
                              ></button> */}
                              <h2 id="modal-quantity-modify-complete-title">数量の変更</h2>
                            </header>
                            <main id="modal-quantity-modify-complete-content">
                              <p>数量の変更を受け付けました。次回のご注文から反映されます。</p>
                            </main>
                            <footer className={base.modalFooter}>
                              <Link
                                className={`${base.sectionBtn}`}
                                data-micromodal-close
                                to={`/subscriptions/${encodeURIComponent(subscription!.subscriptionContractId)}`}
                              >
                                ＯＫ
                              </Link>
                              {/* <button className={base.sectionBtn} data-micromodal-close>
                                ＯＫ
                              </button> */}
                            </footer>
                          </div>
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      <button className={base.sectionBtn} onClick={() => handleAddProduct(product)}>
                        お届け商品に追加
                      </button>
                    </>
                  )}

                  {/* <Link
                  className="select"
                  to={`/subscriptions/${encodeURIComponent(
                    subscription!.subscriptionContractId
                  )}/products/${encodeURIComponent(product.productId)}/lines/${encodeURIComponent(lineId)}`}
                >
                  選択
                </Link> */}
                </footer>
              </div>
            );
          })}
        </div>

        {/* ページネーション */}
        <div className={base.paginationBlock}>
          {prevPageHtml}
          {nextPageHtml}
        </div>
        {/* /ページネーション */}

        {/* 戻るボタン */}
        <div className={base.paginationBlock}>
          <div className={`${base.sectionReverseBtn}`}>
            <Link
              className={`${base.sectionReverseBtnLink}`}
              to={`/subscriptions/${encodeURIComponent(subscription!.subscriptionContractId)}`}
            >
              戻る
            </Link>
          </div>
        </div>
        {/* /戻るボタン */}

        {/* 商品追加時エラーの表示モーダル */}
        <div className="micromodal" id="modal-stock-error" aria-hidden="true">
          <div className={`micromodal-overlay ${base.micromodalOverlay}`} tabIndex={-1}>
            <div
              role="dialog"
              className={base.micromodalOverlayDialog}
              aria-modal="true"
              aria-labelledby="modal-stock-error-title"
            >
              <header>
                {/* <button aria-label="Close modal" className={base.closeModal} data-micromodal-close></button> */}
                <h2 id="modal-stock-error-title">商品の{actionType}</h2>
              </header>
              <main id="modal-stock-error-content">
                <p>
                  在庫がありません。
                  <br />
                  入荷をお待ちいただくか、他の商品に変更をお願いします。
                </p>
              </main>
              <footer>
                <Link
                  className={`${base.sectionBtn} after-delete-btn`}
                  data-micromodal-close
                  to={`/subscriptions/${encodeURIComponent(subscription!.subscriptionContractId)}`}
                >
                  ＯＫ
                </Link>
              </footer>
            </div>
          </div>
        </div>
        {/* /商品追加時エラーの表示モーダル */}

        {/* 商品追加完了後の表示モーダル */}
        <div className="micromodal" id="modal-complete" aria-hidden="true">
          <div className={`micromodal-overlay ${base.micromodalOverlay}`} tabIndex={-1}>
            <div
              role="dialog"
              className={base.micromodalOverlayDialog}
              aria-modal="true"
              aria-labelledby="modal-complete-title"
            >
              <header>
                <h2 id="modal-complete-title">商品の追加が完了しました</h2>
              </header>
              <main id="modal-complete-content">
                <p>
                  以下の商品を追加しました。
                  <br />
                  次回のご注文から変更されます。
                  <br />
                  {/* <br />
                商品：{productDetail ? productDetail!.products![0].title : ''}
                <br />
                {variant ? variant!.title.replace('Default Title', '') : ''} */}
                </p>
              </main>
              <footer>
                <button
                  className={base.sectionBtn}
                  onClick={() => {
                    reactRouterHistory.push(`/subscriptions/${encodeURIComponent(subscription!.subscriptionContractId)}`);
                  }}
                >
                  ＯＫ
                </button>
              </footer>
            </div>
          </div>
        </div>
        {/* /商品追加完了後の表示モーダル */}

        {/* エラー発生時モーダル */}
        <div className="micromodal" id="modal-error" aria-hidden="true">
          <div className={`micromodal-overlay ${base.micromodalOverlay}`} tabIndex={-1}>
            <div role="dialog" className={base.micromodalOverlayDialog} aria-modal="true" aria-labelledby="modal-error-title">
              <header>
                {/* <button aria-label="Close modal" className={base.closeModal} data-micromodal-close></button> */}
                <h2 id="modal-error-title">エラー</h2>
              </header>
              <main id="modal-error-content">
                <p>エラーが発生しました。店舗へお問い合わせください。</p>
                {targetProductDetail && <p>※すべての商品の数量を0にすることはできません。</p>}
              </main>
              <footer>
                <button className={base.sectionBtn} data-micromodal-close>
                  ＯＫ
                </button>
              </footer>
            </div>
          </div>
        </div>
        {/* /エラー発生時モーダル */}

        <div className="micromodal" id="modal-remove-product" aria-hidden="true">
          <div className={`${base.micromodalOverlay} micromodal-overlay`} tabIndex={-1}>
            <div
              role="dialog"
              className={base.micromodalOverlayDialog}
              aria-modal="true"
              aria-labelledby="modal-remove-product-title"
            >
              <header>
                {/* <button aria-label="Close modal" className={base.closeModal} data-micromodal-close></button> */}
                <h2 id="modal-remove-product-title">商品の削除</h2>
              </header>
              <main id="modal-remove-product-content">
                <p>
                  「{oldSubscriptionLine ? oldSubscriptionLine.title : ''}
                  」を削除します。よろしいですか？
                </p>
                <p>※すべての商品の数量を0にすることはできません。</p>
              </main>
              <footer>
                <button className={base.sectionBtn} onClick={onClickRemoveAction} disabled={pageStatus.removeAction}>
                  削除
                </button>
                <button className={base.sectionReverseBtn} data-micromodal-close>
                  戻る
                </button>
              </footer>
            </div>
          </div>
        </div>

        <div className="micromodal" id="modal-remove-product-complete" aria-hidden="true">
          <div className={`${base.micromodalOverlay} micromodal-overlay`} tabIndex={-1}>
            <div
              role="dialog"
              className={base.micromodalOverlayDialog}
              aria-modal="true"
              aria-labelledby="modal-remove-product-complete-title"
            >
              <header>
                {/* <button aria-label="Close modal" className={base.closeModal} data-micromodal-close></button> */}
                <h2 id="modal-remove-product-complete-title">商品の削除</h2>
              </header>
              <main id="modal-remove-product-complete-content">
                <p>「{removeItem ? removeItem.title : ''}」を削除しました。</p>
              </main>
              <footer>
                <Link
                  className={`${base.sectionBtn} after-delete-btn`}
                  data-micromodal-close
                  to={`/subscriptions/${encodeURIComponent(subscription!.subscriptionContractId)}`}
                >
                  ＯＫ
                </Link>
              </footer>
            </div>
          </div>
        </div>

        <div className="micromodal" id="modal-allow-modify-day" aria-hidden="true">
          <div className={`${base.micromodalOverlay} micromodal-overlay`} tabIndex={-1} data-micromodal-close>
            <div
              role="dialog"
              className={base.micromodalOverlayDialog}
              aria-modal="true"
              aria-labelledby="modal-allow-modify-day-title"
            >
              <header>
                {/* <button aria-label="Close modal" className={base.closeModal} data-micromodal-close></button> */}
                <h2 id="modal-allow-modify-day-title">{allowModifyDay.title}</h2>
              </header>
              <main id="modal-allow-modify-day-content">
                <p>
                  {allowModifyDay.title}は次回ご注文日の{allowModifyDay.day}
                  日前以降はご利用できません。
                  <br />
                  次回のご注文日、【{dayjs(subscription.nextBillingDate).format('YYYY/MM/DD')}
                  】以降にご利用が可能となります。
                </p>
              </main>
              <footer>
                <button className={base.sectionBtn} data-micromodal-close>
                  ＯＫ
                </button>
              </footer>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
